import { Node } from 'slate'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { GenerateContentElement } from '../nodes/GenerateContentElement'

export function getGeneratedContent({
  editor,
}: {
  editor: BufferEditor
}): string | null {
  const suggestion = editor.api.node({
    at: [],
    match: (n) => GenerateContentElement.is(n),
  })

  return suggestion ? Node.string(suggestion[0]) : null
}
